import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

const VMSRegion = ({ onChange }: { onChange: (data: string) => void }) => (
  <Grid container>
    <Grid item xs={12}>
      <WsTypography variant={WsTypoVariants.SUB_TITLE}>Please select region</WsTypography>
      <RadioGroup row={true} onChange={(e) => onChange(e.target.value)}>
        {region.map((singleOption) => (
          <FormControlLabel
            key={singleOption.value}
            value={singleOption.value}
            label={singleOption.label}
            control={<Radio size="medium" />}
          />
        ))}
      </RadioGroup>
    </Grid>
  </Grid>
);

const region = [
  {
    label: 'US',
    value: 'US',
  },
  {
    label: 'EU',
    value: 'EU',
  },
];

export default VMSRegion;
